/*
  assets/hub-brands-carousel.js
  ---------------------------------------------------------------------------
  "Brands that complement your work" para Nivel 1 (Página, ej. "Fittings &
  Valves") — a pedido, implementado también acá.

  Por qué un script aparte y no reutilizar hub-storefront-filters.js: ese
  controlador reconstruye el sidebar de filtros COMPLETO (precio,
  disponibilidad, etc.) — Nivel 1 no tiene grilla de productos propia que
  filtrar (ver sections/pages-hub.liquid, is_level_1), así que cargar todo
  ese motor solo para esto sería peso muerto. Este archivo solo pide el
  filtro de marca (ProductFilter) de la colección de referencia vía
  Storefront API — misma limitación de plataforma que motivó
  hub-storefront-filters.js (collection.filters SIEMPRE viene vacío en un
  template de Página, sin importar cómo se resuelva el objeto Collection
  en Liquid — confirmado esta sesión, no es un bug de código).

  A diferencia de Nivel 2 (donde cada chip de marca aplica el filtro al
  vuelo sobre el mismo grid), acá cada chip es un link real a la propia
  colección de esa marca — Nivel 1 no tiene grid que filtrar, así que
  "aplicar el filtro" no tendría a qué aplicarse. Mismo criterio que ya
  usa la versión SSR de este bloque (sections/collection-hub.liquid,
  sections/main-collection.liquid, sobre Colección real): si existe una
  colección con el handle de la marca, se linkea ahí (con logo si esa
  colección tiene imagen); si no existe ninguna colección para esa marca,
  se omite del carril en vez de mostrar un chip sin destino real.
*/
(function () {
  'use strict';

  function handleize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function StorefrontClient(shopDomain, token, apiVersion) {
    this.endpoint = 'https://' + shopDomain + '/api/' + apiVersion + '/graphql.json';
    this.token = token;
  }

  StorefrontClient.prototype.query = function (query, variables) {
    return fetch(this.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.token,
      },
      body: JSON.stringify({ query: query, variables: variables }),
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.errors && json.errors.length) {
          throw new Error(json.errors.map(function (e) { return e.message; }).join('; '));
        }
        return json.data;
      });
  };

  // Igual que products(first: 1) { filters {...} } que ya usa
  // hub-storefront-filters.js en otro punto puntual (buscar filtros sin
  // pedir datos reales de producto) — solo se necesita el filtro de
  // marca, no el grid.
  var FILTERS_QUERY = [
    'query HubBrandsFilter($handle: String!) {',
    '  collection(handle: $handle) {',
    '    products(first: 1) {',
    '      filters { id label type values { id label count input } }',
    '    }',
    '  }',
    '}',
  ].join('\n');

  function findBrandFilter(filters) {
    return (filters || []).filter(function (f) {
      var lbl = (f.label || '').toLowerCase();
      return lbl.indexOf('brand') !== -1 || lbl.indexOf('vendor') !== -1;
    })[0];
  }

  // Mismo patrón de consulta multi-alias que fetchBrandLogos en
  // hub-storefront-filters.js — un solo round-trip para TODAS las marcas
  // en vez de uno por marca. Acá se pide además handle/url (no solo
  // image): a diferencia de Nivel 2 (que solo necesita el logo porque el
  // chip filtra el grid en vivo, sin navegar), acá cada chip SÍ necesita
  // saber si existe una colección real para poder linkear — o para
  // omitirse del carril si no existe ninguna.
  function fetchBrandCollections(client, handles) {
    if (!handles.length) return Promise.resolve({});
    var variableDefs = [];
    var variables = {};
    var fields = [];
    handles.forEach(function (h, i) {
      var varName = 'h' + i;
      variableDefs.push('$' + varName + ': String!');
      variables[varName] = h;
      fields.push('c' + i + ': collection(handle: $' + varName + ') { handle onlineStoreUrl image { url altText width height } }');
    });
    var query = 'query BrandCollections(' + variableDefs.join(', ') + ') {\n' + fields.join('\n') + '\n}';
    return client.query(query, variables).then(function (data) {
      var result = {};
      handles.forEach(function (h, i) {
        result[h] = (data && data['c' + i]) || null;
      });
      return result;
    });
  }

  function brandCardHtml(label, collectionData) {
    // onlineStoreUrl viene null si la colección existe pero NO está
    // publicada al canal Online Store — correcto omitirla en ese caso
    // también (no hay a dónde mandar el click).
    if (!collectionData || !collectionData.onlineStoreUrl) return '';
    if (collectionData.image) {
      var img = collectionData.image;
      var ratio = (img.width && img.height) ? (img.width / img.height) : 1;
      return '<a href="' + collectionData.onlineStoreUrl + '" class="hub-brand-card">' +
        '<span class="hub-brand-card__logo-wrap"><img class="hub-brand-card__logo" src="' + img.url + '" alt="' + escapeHtml(label) + ' logo" loading="lazy" width="200" height="' + Math.round(200 / ratio) + '"></span>' +
        '<span class="hub-brand-card__name">' + escapeHtml(label) + '</span></a>';
    }
    return '<a href="' + collectionData.onlineStoreUrl + '" class="hub-brand-card">' +
      '<span class="hub-brand-card__name hub-brand-card__name--only">' + escapeHtml(label) + '</span></a>';
  }

  document.querySelectorAll('[data-hub-brands-carousel]').forEach(function (root) {
    var handle = root.dataset.collectionHandle;
    var shopDomain = root.dataset.shopDomain;
    var token = root.dataset.storefrontToken;
    var apiVersion = root.dataset.storefrontApiVersion;
    var rail = root.querySelector('.hub__brands-rail');
    if (!handle || !shopDomain || !token || !apiVersion || !rail) return;

    var client = new StorefrontClient(shopDomain, token, apiVersion);

    client.query(FILTERS_QUERY, { handle: handle }).then(function (data) {
      var conn = data && data.collection && data.collection.products;
      var brandFilter = findBrandFilter(conn && conn.filters);
      if (!brandFilter || !brandFilter.values.length) return;

      var handles = brandFilter.values.map(function (v) { return handleize(v.label); });
      return fetchBrandCollections(client, handles).then(function (collectionsByHandle) {
        var html = brandFilter.values.map(function (v) {
          return brandCardHtml(v.label, collectionsByHandle[handleize(v.label)]);
        }).join('');
        if (!html) return;
        rail.innerHTML = html;
        root.hidden = false;
      });
    }).catch(function (err) {
      console.error('[hub-brands-carousel] no se pudo calcular el bloque de marcas:', err);
    });
  });
})();
